import { render, staticRenderFns } from "./CompaniesDepartments.vue?vue&type=template&id=e70e2366&scoped=true&"
import script from "./CompaniesDepartments.vue?vue&type=script&lang=js&"
export * from "./CompaniesDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70e2366",
  null
  
)

export default component.exports